import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetOfferLinkRequest = App.Http.Requests.OfferLink.GetOfferLinkRequest;
import GetOfferLinksRequest = App.Http.Requests.OfferLink.GetOfferLinksRequest;
import StoreOfferLinkRequest = App.Http.Requests.OfferLink.StoreOfferLinkRequest;
import UpdateOfferLinkRequest = App.Http.Requests.OfferLink.UpdateOfferLinkRequest;
import GetOfferLinkResponse = App.Http.Responses.OfferLink.GetOfferLinkResponse;
import GetOfferLinksResponse = App.Http.Responses.OfferLink.GetOfferLinksResponse;

class OfferLinkApi extends TenantBaseApi {
    /**
     * Get list of offer links
     *
     * - Request: GetOfferLinksRequest
     * - Response: GetOfferLinksResponse
     */
    async index(request: GetOfferLinksRequest): Promise<GetOfferLinksResponse> {
        return await this.get<GetOfferLinksResponse, GetOfferLinksRequest>("/offer-links", {
            params: request,
        });
    }

    /**
     * Get a specific offer link by ID
     *
     * - Request: { id: string }
     * - Response: GetOfferLinkResponse
     */
    async show(requestId: string, request?: GetOfferLinkRequest): Promise<GetOfferLinkResponse> {
        return await this.get<GetOfferLinkResponse, GetOfferLinkRequest>(`/offer-links/${requestId}`, {
            params: request,
        });
    }

    /**
     * Store a new offer link
     *
     * - Request: StoreOfferLinkRequest
     * - Response: GetOfferLinkResponse
     */
    async store(request: StoreOfferLinkRequest): Promise<GetOfferLinkResponse> {
        return await this.post<GetOfferLinkResponse, StoreOfferLinkRequest>("/offer-links", request);
    }

    /**
     * Update an offer link by ID
     *
     * - Request: UpdateOfferLinkRequest
     * - Response: GetOfferLinkResponse
     */
    async update(requestId: string, request: UpdateOfferLinkRequest): Promise<GetOfferLinkResponse> {
        return await this.patch<GetOfferLinkResponse, UpdateOfferLinkRequest>(`/offer-links/${requestId}`, request);
    }

    /**
     * Delete an offer link by ID
     *
     * - Request: { id: string }
     * - Response: void
     */
    async destroy(requestId: string): Promise<void> {
        return await this.delete<void>(`/offer-links/${requestId}`);
    }
}

export const offerLinkApi = new OfferLinkApi();
